// extracted by mini-css-extract-plugin
module.exports =  {"dropdown":"_35875ce240--dropdown--Luo8X"};